import { render, staticRenderFns } from "./MultiChoiceCheckpoint.vue?vue&type=template&id=5e2248af&scoped=true&"
import script from "./MultiChoiceCheckpoint.vue?vue&type=script&lang=js&"
export * from "./MultiChoiceCheckpoint.vue?vue&type=script&lang=js&"
import style0 from "./MultiChoiceCheckpoint.vue?vue&type=style&index=0&id=5e2248af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2248af",
  null
  
)

export default component.exports